import { SideNavToggleButton } from '@atlaskit/navigation-system/layout/side-nav';

export const TopNavToggleSideNavButton = (): JSX.Element => {
  return (
    <SideNavToggleButton
      collapseLabel="Collapse sidebar"
      expandLabel="Expand sidebar"
    />
  );
};
